export default '/build/032d1e3c.jpg'